
<template>
    <el-dialog :title="title" append-to-body :visible.sync="dialogVisible">
        <!-- <avue-tree :data="treeData" :option="treeOption" @node-click="nodeClick">
        </avue-tree> -->
        <el-input
            placeholder="输入关键字"
            v-model="filterText">
            </el-input>
            <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            :default-checked-keys="selectGroupIds"
            :filter-node-method="filterNode"
            @current-change="nodeClick"
            :props="defaultProps" ref="tree2">
        </el-tree>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="formSubmit">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {workerAddGroup} from '@/api/admin/groups'
import waves from '@/directive/waves/index.js' // 水波纹指令
import { objKeySort } from '@/util/ajaxsign'
export default {
    name: 'group',
    directives: {
        waves
    },
    watch: {
      filterText(val) {
        this.$refs.tree2.filter(val);
      }
    },
    data() {
        return {
            title : '设置群组',
            filterText:'',
            dialogVisible:false,
            formData:{
                groupIds:'',
                urId:''
            },
            selectGroupIds:[],
            // treeData:{},
            treeOption:{

                nodeKey:'id',
                multiple: true,
                props:{
                    labelText:'设置群组',
                    label:'groupName',
                    value:'id'
                }
            },
            defaultProps: {
                label:'groupName',
                value:'id'
            }
        }
    },
    props:["treeData"],
    created() {},
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.groupName.indexOf(value) !== -1;
        },
        nodeClick(value,node){
            if(node.checked){
                node.checked = false;
            }else{
                node.checked = true;
            }

        },
        //查看数据展示
        setData(workerId,urId,treeData,groupIds){
            this.formData.urId = urId;
            // this.treeData = treeData;
            this.dialogVisible = true;
            if(groupIds){
                this.selectGroupIds = groupIds.split(',');
            }
        },

        formSubmit(){
            this.formData.groupIds = '';
            if(this.$refs.tree2.getCheckedKeys()){
                this.$refs.tree2.getCheckedKeys().forEach(key => {
                    this.formData.groupIds = this.formData.groupIds + key +',';
                });
            }
            if(this.formData.groupIds&&this.formData.groupIds.length>0){
                this.formData.groupIds = this.formData.groupIds.substring(0,this.formData.groupIds.length-1);
            }else{
                alert("请选择群组");
                return;
            }
            workerAddGroup(objKeySort(this.formData)).then(response => {
                if(response&&response.data&&response.data.code===200){
                    this.$message({
                        title: '成功',
                        message: '分组成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.$refs.tree2.setCheckedKeys([]);
                    this.dialogVisible = false;
                    this.$emit('refresh');


                }else{
                    this.$message({
                        title: '失败',
                        message: '分组失败',
                        type: 'error',
                        duration: 2000
                    })
                }
            });
        }
    }
}
</script>
